export class MemberRequestInfo {
    public InformationRequired: string;
    public SelectedRole: string;
    public FPStaffEmail: string;
    public Message: string
    public MemberId: number;
}